// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const mawile_mega: PokeData = {
  "id": 10052,
  "name": "mawile-mega",
  "height": 10,
  "weight": 235,
  "base_experience": 168,
  "types": [
    PokeType.STEEL,
    PokeType.FAIRY
  ],
  "api_moves": [
    "vice-grip",
    "bite",
    "growl",
    "feint-attack",
    "baton-pass",
    "sweet-scent",
    "crunch",
    "stockpile",
    "spit-up",
    "swallow",
    "taunt",
    "astonish",
    "fake-tears",
    "iron-defense",
    "sucker-punch",
    "iron-head",
    "play-rough",
    "fairy-wind"
  ],
  "moves": [
    "bite",
    "growl",
    "crunch",
    "play-rough",
    "meteor-mash",
    "metal-burst",
    "metal-sound",
    "mist-terrain",
    "scrap-throw",
    "moonlight",
    "gear-up",
    "iron-defense",
    "hyper-voice"
  ],
  "evolution_chain": {
    "id": 150,
    "item": null,
    "species": [
      {
        "name": "mawile",
        "order": 329,
        "types": [
          PokeType.STEEL,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 136,
    "speed": 85,
    "ability_power": 179
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
